import axios from 'axios';
import Cookies from 'js-cookie';
import cache from '@/plugins/cache';
import { message, notification } from 'ant-design-vue';
import i18n from '@/configs/i18n';
import { getToken, removeToken, getTenant, removeTenant } from "./auth";
const { t } = i18n.global;

const errorCode = {
  '401': t('requestError.tokenExpires'),
  '403': t('requestError.permissionDenied'),
  '404': t('requestError.notFound'),
  default: t('requestError.default'),
};

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params: { [x: string]: any }) {
  let result = '';
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    const part = encodeURIComponent(propName) + '=';
    if (value !== null && value !== '' && typeof value !== 'undefined') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (
            value[key] !== null &&
            value[key] !== '' &&
            typeof value[key] !== 'undefined'
          ) {
            const params = propName + '[' + key + ']';
            const subPart = encodeURIComponent(params) + '=';
            result += subPart + encodeURIComponent(value[key]) + '&';
          }
        }
      } else {
        result += part + encodeURIComponent(value) + '&';
      }
    }
  }
  return result;
}

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers['Expires'] = 0;
axios.defaults.headers['Pragma'] = 'no-cache';
axios.defaults.headers['Cache-control'] = 'no-cache, no-store, must-revalidate';
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: 'http://192.168.101.41:8079/api',
  // baseURL: 'http://192.168.101.32:38080/api',
  // baseURL: 'https://smallppt.com/api',

  // 超时
  timeout: 30000,
});

// request拦截器
service.interceptors.request.use(
  config => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false;
    if (getToken() && !isToken) {
      config.headers['Authorization'] = 'Bearer ' + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // 添加租户id
    if (getTenant()) {
      config.headers['tenant-id'] = getTenant(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?' + tansParams(config.params);
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    if (
      !isRepeatSubmit &&
      (config.method === 'post' || config.method === 'put')
    ) {
      const requestObj = {
        url: config.url,
        data:
          typeof config.data === 'object'
            ? JSON.stringify(config.data)
            : config.data,
        time: new Date().getTime(),
      };
      const sessionObj = cache.session.getJSON('sessionObj');
      if (
        sessionObj !== undefined &&
        sessionObj !== null &&
        sessionObj !== ''
      ) {
        const s_url = sessionObj.url; // 请求地址
        const s_data = sessionObj.data; // 请求数据
        const s_time = sessionObj.time; // 请求时间
        const interval = 1000; // 间隔时间(ms)，小于此时间视为重复提交
        if (
          s_data === requestObj.data &&
          requestObj.time - s_time < interval &&
          s_url === requestObj.url
        ) {
          const messageInfo = t(`errorCode.notReDo`);
          return Promise.reject(new Error(messageInfo));
        }
      }
    }
    return config;
  },
  error => {
    console.log(error);
    Promise.reject(error);
  }
);

// 是否显示重新登录
export const isRelogin = { show: false };

// 响应拦截器
service.interceptors.response.use(
  res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code as keyof typeof errorCode] || res.data.msg || errorCode['default'];
    // 二进制数据则直接返回
    if (
      res.request.responseType === 'blob' ||
      res.request.responseType === 'arraybuffer'
    ) {
      return res.data;
    }

    if (code === 401) {
      if (!isRelogin.show) {
        removeToken();
        removeTenant();
      }
      return Promise.reject(t(`errorCode.loginMsg`));
    } else if (code === 500) {
      message.error(msg);
      // return Promise.reject(msg)
    } else if (code === 601) {
      message.warning(msg);
      return Promise.reject('error');
    } else if (code === 1004) {
      return Promise.reject(res);
    } else if (code !== 200) {
      notification['error']({
        message: t(`public.systemMsg`),
        description: msg,
      });
      return Promise.reject('error');
    }
    return res.data;
  },
  error => {
    console.log('err' + error);
    // let { msg } = error
    let msg: any = error.message;
    if (msg === 'Network Error') {
      msg = t('requestError.networkError');
    } else if (msg.includes('timeout')) {
      msg = t('requestError.requestTimeOut');
    } else if (msg.includes('Request failed with status code')) {
      msg = t('requestError.requestFailed');
    }
    message.error(t(`errorCode.errMsg`) || msg);
    return Promise.reject(error);
  }
);

export default service;
